import { SpinResponse } from '@cgs/data-access';
import { CgsEvent } from '@cgs/wge';
import { BaseGameRule } from './base_game_rule';
import { BaseGameState } from '../../states/base_game_state';
import { ResponseHolder } from '../../response_holder';

export abstract class InterruptStateRule<
  TResponse extends SpinResponse,
> extends BaseGameRule<TResponse> {
  protected constructor(
    sourceState: BaseGameState<TResponse>,
    responseHolder: ResponseHolder<TResponse>
  ) {
    super(sourceState, responseHolder);
  }

  dispatchEvent(event: CgsEvent): void {
    if (this.eventTest(event)) {
      this.sourceState.interrupt();
      if (this.ruleCondition(this.responseHolder)) {
        this.triggered = true;
      }
    }
  }

  protected abstract eventTest(event: CgsEvent): boolean;
}
